import { Link, useNavigate } from '@tanstack/react-router';
import { config } from 'config';
import { ArrowDown, Check } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollSpy } from '~/hooks/use-scroll-spy';
import { WaitlistForm } from '~/modules/auth/waitlist-form';
// import Counters from '~/modules/marketing/about/counters';
import FAQ from '~/modules/marketing/about/faq';
// import Features from '~/modules/marketing/about/features';
import { Hero } from '~/modules/marketing/about/hero';
import Pricing from '~/modules/marketing/about/pricing';
import { AboutSection } from '~/modules/marketing/about/section';
// import Integrations from '~/modules/marketing/about/integrations';
import Why from '~/modules/marketing/about/why';
import { MarketingFooter } from '~/modules/marketing/footer';
import { MarketingNav } from '~/modules/marketing/nav';
import { buttonVariants } from '~/modules/ui/button';
import { cn } from '~/utils/cn';

import '~/modules/marketing/about/glow-button.css';
import { useBreakpoints } from '~/hooks/use-breakpoints';

export type AboutSectionId = (typeof aboutSectionIds)[number];

const aboutSectionIds = ['hero', 'product', 'pricing', 'faqs'];

const AboutPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useBreakpoints('max', 'sm', false);

  const [joinedToWaitlist, setJoinedToWaitlist] = useState(false);

  useScrollSpy({ sectionIds: aboutSectionIds });

  return (
    <>
      <MarketingNav />

      <div className="container max-w-none px-0">
        {/* Hero landing */}
        <Hero key={'hero'} title="about:title_1" subtitle="about:subtitle" text={isMobile ? undefined : 'about:text_1'}>
          {joinedToWaitlist ? (
            <span className="flex gap-2 justify-between items-center border-2 rounded-full px-4 py-3.5 ring-4 ring-primary/5 border-success">
              <Check className="text-success w-8" size={20} />
              <span className="opacity-60">{t('common:in_waitlist', { appName: config.name })}</span>
            </span>
          ) : (
            <WaitlistForm email="" buttonContent={`${t('common:waitlist_request')}`} emailField callback={() => setJoinedToWaitlist(true)} />
          )}

          <Link
            to="/about"
            replace
            hash="product"
            onClick={(e) => {
              // if (window.location.hash !== '#product') return;
              e.preventDefault();
              navigate({ to: '.', hash: 'top', replace: true });

              // TODO temp fix while Link component doesn't support hash scroll into view
              const anchor = document.getElementById('why');
              anchor?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

              setTimeout(() => {
                navigate({ hash: 'product', replace: true });
              }, 20);
            }}
            className={cn('mt-8', buttonVariants({ variant: 'ghost', size: 'lg' }))}
            aria-label="Read more"
          >
            <span className="font-light">{t('about:why')}</span>
            <ArrowDown size={16} className="ml-2 animate-bounce" />
          </Link>
        </Hero>

        <div className="my-12">
          {/* Why this product */}
          <AboutSection key={'product'} section="product" title="about:title_2" text="about:text_2">
            <Why />
          </AboutSection>

          {/* Showcase */}
          {/* <AboutSection key={'showcase'} section="showcase" title="about:showcase" text="about:showcase.text">
            <Showcase />
          </AboutSection> */}

          {/* Call to Action */}
          {/* <AboutSection key={'call-to-action'} section="call-to-action" alternate={true}>
            <CallToAction />
          </AboutSection> */}

          {/* Features */}
          {/* <AboutSection key={'features'} section="features" title="about:title_3" text="about:text_3" alternate={true}>
            <Features />
          </AboutSection> */}

          {/* Integrations */}
          {/* <AboutSection key={'integrations'} section="integrations" title="about:title_4" text="about:text_4">
            <Integrations />
          </AboutSection> */}

          {/* Pricing */}
          <AboutSection key={'pricing'} section="pricing" title="about:title_6" text="about:text_6">
            <Pricing />
          </AboutSection>

          {/* FAQs */}
          <AboutSection key={'faqs'} section="faqs" title="about:title_7" text="about:text_7" alternate={true}>
            <FAQ />
          </AboutSection>

          {/* Public counters */}
          {/* <AboutSection key={'counters'} section="counters" title="about:title_5" text="about:text_5">
            <Counters />
          </AboutSection> */}
        </div>
      </div>
      <MarketingFooter />
    </>
  );
};

export default AboutPage;
